class WarehouseEntity {
  constructor({ ...data }) {
    this.client_warehouse_id = data?.id;
    this.client_warehouse_name = data?.name;
  }
}

export default WarehouseEntity;
